import React from 'react'
import PropTypes from 'prop-types'
import RemoveIcon from '@material-ui/icons/RemoveCircle'
import Collection from './components/Collection'
import linkTypes from './enums/linkTypes'
import SearchBox from './components/SearchBox'
import displayModes from './enums/displayModes'
import searchTypes from './enums/searchTypes'
import connectPropTypes from './utilities/connectPropTypes'
import preventableBinder from './utilities/preventableBinder'
import getNormalisedParameters from './utilities/getNormalisedParameters'
import getDecodedURIComponent from './utilities/getDecodedURIComponent'
import styles from './PostTag.icss'
import entityTypes from './enums/entityTypes'
import Thing from './utilities/Data/Thing'

const hasBeenTagged = (thing, tags) => {
	const hasTags = !!(tags && tags.length > 0)
	if (!hasTags) {
		return false
	}
	return tags.some(tag => Thing.isSameThing(thing, tag))
}

class PostTag extends React.Component {
	constructor(props) {
		super(props)

		const parsedSearch = getNormalisedParameters(this.props.location.search)
		this.state = {
			kitId: getDecodedURIComponent(parsedSearch.kitid || props.match.params.kitId),
			// searchType: searchTypes.EVERYTHING.type
			searchType: searchTypes.USER.type
		}

		this.selectItemHandler = preventableBinder(this.selectItemHandler.bind(this), 'itemForKit')
		this.bindHandleDeleteButtonClick = this.bindHandleDeleteButtonClick.bind(this)
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Add someone to your post') })
		this.props.appBottomBarValue(linkTypes.ADD)
		this.props.appShowBottomBar(false)
		this.props.appShowBottomNavBar(true)
		this.props.appBottomNavBarHandleClick(() => {
			this.props.appRedirect(`/post/edit${this.state.kitId ? `?kitId=${this.state.kitId}` : ''}`)
		})
		this.props.appBottomNavBarLabelNext(this.context.translate('DONE'))
	}

	componentDidUpdate() {
		this.props.appPageLoaded(true)
	}

	selectItemHandler(thing) {
		this.props.postDraftAddTag({ tag: Thing.getTag(thing), thing })
		this.props.appRedirect(`/post/edit${this.state.kitId ? `?kitId=${this.state.kitId}` : ''}`)
	}

	bindHandleDeleteButtonClick(thing) {
		return () => {
			this.props.postDraftRemoveTag({ thing })
		}
	}

	render() {
		const hasAllSearchResults = this.props.searchItemResults && this.props.searchKitResults && this.props.searchUserResults
		const renderAfterItem = (renderProps) => {
			const aItem = renderProps.item
			const displayMode = renderProps.displayMode
			return (
				<React.Fragment>
					{hasBeenTagged(aItem, (this.props.postDraft && this.props.postDraft.tags) || []) && (
						<button
							key={`button${aItem.objectID}`}
							type="button"
							className={styles.addedTag}
							onClick={this.bindHandleDeleteButtonClick(aItem)}
						>
							<span>
								<RemoveIcon className={styles.removeTag} />
							</span>
							<span className={styles[`added${displayMode}`]}>
								{this.context.translate('Tagged!')}
							</span>
						</button>
					)}
				</React.Fragment>
			)
		}

		return (
			<section>
				<div className={styles.inputLine}>
					<div key="searchInput" className={styles.searchInput}>
						<SearchBox
							searchType={this.state.searchType}
							hintText={this.context.translate('Search for users')}
							searchOnMount={false}
							searchTypeOverride={searchTypes.EVERYTHING.type}
							autoFocus
						/>
					</div>
				</div>

				<div className={styles.items}>
					{hasAllSearchResults && (
						<Collection
							classes={{ itemRoot: styles.itemRoot }}
							// allowedDisplayModes={[displayModes.LIST.type, displayModes.GRID.type]}
							allowedDisplayModes={[displayModes.LIST.type]}
							defaultDisplayMode={displayModes.LIST.type}
							// filterOptions={[{ name: searchTypes.EVERYTHING.name, value: searchTypes.EVERYTHING.type }, { name: searchTypes.ITEM.name, value: searchTypes.ITEM.type }, { name: searchTypes.KIT.name, value: searchTypes.KIT.type }, { name: searchTypes.USER.name, value: searchTypes.USER.type }]}
							// onFilterChange={value => this.setState({ searchType: value })}
							isLoading={this.props.searchLoading}
							itemDescription={Thing.description}
							itemIconName={Thing.propertyGetter({
								// [entityTypes.KIT.type]: this.state.displayMode === displayModes.GRID.type ? 'whiteKit' : 'blackKit',
								[entityTypes.USER.type]: this.state.displayMode === displayModes.GRID.type ? 'whiteUser' : 'blackUser'
							})}
							itemImageContent={Thing.images}
							itemKey={Thing.key}
							itemSubtitle={Thing.subtitle}
							itemTitle={Thing.title}
							itemOnSelect={this.selectItemHandler}
							items={Thing.getSearchResults(this.state.searchType, this.props)}
							renderAfterItem={renderAfterItem}
							showResultsSeparator
						/>
					)}
				</div>
			</section>
		)
	}
}

PostTag.contextTypes = {
	translate: PropTypes.func
}

PostTag.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
		search: PropTypes.string
	}).isRequired,
	match: PropTypes.shape({
		params: PropTypes.object.isRequired
	}).isRequired,
	appHeading: PropTypes.func.isRequired,
	appBottomBarValue: PropTypes.func.isRequired,
	// appMessage: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appPageLoaded: PropTypes.func.isRequired,
	postDraftAddTag: PropTypes.func.isRequired,
	postDraftRemoveTag: PropTypes.func.isRequired,
	postDraft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	searchLoading: PropTypes.bool,
	searchItemResults: PropTypes.array, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
	searchKitResults: PropTypes.array, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
	searchUserResults: PropTypes.array // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
}

PostTag.defaultProps = {
	searchLoading: false,
	searchItemResults: undefined,
	searchKitResults: undefined,
	searchUserResults: undefined,
	postDraft: undefined
}

export const testing = {
	PostTag
}

export default connectPropTypes(PostTag)



// WEBPACK FOOTER //
// ./src/PostTag.jsx